import "./About.module.css";
import Header from "@/reusable_sections/Header";
import NaturalColorsExplosion from "./sections/NaturalColorsExplosion";
import AboutVisual from "./sections/AboutVisual";
import WhyRollkon from "./sections/WhyRollkon";
import DirectFromTheSource from "./sections/DirectFromTheSource";
import TheVistProcess from "./sections/TheVistProcess";
import WordFromTheField from "./sections/WordFromTheField";
import ContactInformation from "./sections/ContactInformation";
import PrecisaDeAjudaTecnica from "./sections/PrecisaDeAjudaTecnica";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <NaturalColorsExplosion />
      <AboutVisual />
      <WhyRollkon />
      <DirectFromTheSource />
      <TheVistProcess />
      <WordFromTheField />
      <ContactInformation />
      <PrecisaDeAjudaTecnica />
      <Footer />
    </div>;
}